"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareAndEarnBanner = void 0;
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Displays banner with info about Share&Earn. Should be clickable to open a Dialog.
 * Does not render if `title` has falsy value.
 */
const ShareAndEarnBanner = ({
  title,
  className,
  arrowAlwaysCentered,
  onClick
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (!title) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.SHARE_AND_EARN_BANNER),
    onClick: onClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Share, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Title, {
      fontWeight: "bold",
      variant: "caption",
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Arrow, {
      arrowAlwaysCentered: arrowAlwaysCentered
    })]
  });
};
exports.ShareAndEarnBanner = ShareAndEarnBanner;
